import { render } from "./ContractsView.vue?vue&type=template&id=5d7bf956"
import script from "./ContractsView.vue?vue&type=script&lang=js"
export * from "./ContractsView.vue?vue&type=script&lang=js"

import "./ContractsView.vue?vue&type=style&index=0&id=5d7bf956&lang=css"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__